var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.52978V12.5336C20.0001 13.3496 19.6824 14.1348 19.1123 14.7279C18.5422 15.3211 17.7628 15.6773 16.934 15.7235L16.75 15.7284H3.25C2.41986 15.7285 1.62117 15.4162 1.01777 14.8558C0.414367 14.2954 0.0519987 13.5292 0.00500011 12.7145L0 12.5336V4.52978L9.652 9.49996C9.75938 9.55525 9.87879 9.58413 10 9.58413C10.1212 9.58413 10.2406 9.55525 10.348 9.49996L20 4.52978ZM3.25 2.32044e-08H16.75C17.5556 -9.53679e-05 18.3325 0.29392 18.93 0.825021C19.5276 1.35612 19.9032 2.08645 19.984 2.87437L10 8.01559L0.016 2.87437C0.0935234 2.11774 0.44305 1.41312 1.00175 0.887144C1.56045 0.361172 2.29168 0.0483521 3.064 0.00491526L3.25 2.32044e-08Z",
    fill: "url(#paint0_linear_1_6106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_6106",
    x1: 0,
    y1: 0,
    x2: 22.7219,
    y2: 7.86495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48E02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBox);
export default __webpack_public_path__ + "static/media/messageBox.88bd835b7e8abea69bf1d81186921e35.svg";
export { ForwardRef as ReactComponent };